import React, { useState, useEffect } from 'react';
import { Box, Card, CardContent, Typography, useMediaQuery, Button, Dialog, Divider, DialogTitle, DialogContent, DialogContentText, DialogActions, Checkbox, CircularProgress} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import {db} from '../../firebaseConfig';

import {generateUniqueId} from '../../common/ItemNumberGenerator'; 

import TicketingAndRegistrationInputModal from './TicketingAndRegistrationInputModal';
import TicketingAndRegistrationDrawerModal from './TicketingAndRegistrationDrawerModal';
import { tokens } from '../../theme';
import Header from '../../components/Header';
import { IconButton, Menu, MenuItem} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';

import EditIcon from '@mui/icons-material/EditOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import FileCopyIcon from '@mui/icons-material/FileCopyOutlined';

import { logToast } from '../../common/ToastMessageLogger';

import noRecordImage from './no_ticketingandregistrations.png'; //All Lowercase with underscore

import Tile from './TicketingAndRegistrationTile';

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";


    const generateEventColorMap = (ticketingAndRegistrations, eventMap,theme) => {

    const eventIdColorMap = {};
    
    const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
    
    ticketingAndRegistrations.forEach(ticketingAndRegistration => {
        if (!eventIdColorMap[ticketingAndRegistration.eventId]) {
        eventIdColorMap[ticketingAndRegistration.eventId] = colorFunction(ticketingAndRegistration.eventId);
        }
    });
    
    return eventIdColorMap;
    };
    
const generateRegistrationStatusColorMap = (ticketingAndRegistrations,theme) => {
  
        const registrationStatusColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        ticketingAndRegistrations.forEach(ticketingAndRegistration => {
          if (!registrationStatusColorMap[ticketingAndRegistration.registrationStatus]) {
            registrationStatusColorMap[ticketingAndRegistration.registrationStatus] = colorFunction(ticketingAndRegistration.registrationStatus);
          }
        });
      
        return registrationStatusColorMap;
      };
      
 

const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  return stringToColorLight(str);
};

const stringToColorDarkOLD = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always dark by restricting them to the first half of 256
    const darkValue = value % 128;
    color += ('00' + darkValue.toString(16)).substr(-2);
  }
  return color;
};


const formatFirestoreDate = timestamp => {

  if (timestamp != null && timestamp !== "")
  {
    const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
    const parts = dateStr.split('-');
    return `${parts[1]}/${parts[2]}/${parts[0]}`;
  } else 
  {
    return "";
  }
};

const formatFirestoreTime = timestamp => {

 if (timestamp != null && timestamp !== "")
 { 
      // Convert the seconds since Unix epoch to a Date object
    const date = new Date(timestamp.seconds * 1000);

    // Extract hours and minutes
    let hours = date.getHours();
    const minutes = date.getMinutes();

    // Determine AM or PM
    const period = hours >= 12 ? 'PM' : 'AM';

    // Convert hours to 12-hour format
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    // Format hours and minutes as a time string in "hh:mm AM/PM" format
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes} ${period}`;
 } else
 {
  return "";
 }
};


const formatPhoneNumber = value => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

const formatCurrencyInteger = value => {

  if (value != null && value !=="")
  {
    return `$${Number(value).toLocaleString()}`;
  } else 
  {
    return "";
  }
};

const formatCurrency = (value) => {

  if (value != null && value !=="")
  {
        value = value.toString();
        // Remove all non-numeric characters except for the decimal point
        let result = value.replace(/[^0-9.]/g, '');
      
        // If there are multiple decimal points, keep only the first one
        const parts = result.split('.');
        if (parts.length > 2) {
          result = parts[0] + '.' + parts.slice(1).join('');
        }
      
        // Allow at most two decimal places
        if (parts.length === 2 && parts[1].length > 2) {
        
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
        } else if (parts.length === 2 && parts[1].length <= 2) 
        {
          result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        }else
        {
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return result ? `$${result}` : '';

    } else 
    {
      return "";
    }
};



const ItemType = {
  CARD: 'card',
};

const DraggableCard = ({ ticketingAndRegistration, index, moveCard, ticketType, setEditingTicketingAndRegistration, setDeleteId, setConfirmOpen, ticketingAndRegistrations, setShowModal, colors,theme,deleteSelectionModel,setDeleteSelectionModel,setEditingData,handleDeleteSingleItem,setDrawerOpen ,eventMap, formatEvent,eventColorMap,registrationStatusColorMap }) => {
  const [, ref] = useDrag({
    type: ItemType.CARD,
    item: { id: ticketingAndRegistration.id, index, ticketType },
  });

    const handleDeleteSelectionChange = (id) => {
   
      setDeleteSelectionModel((prev) =>
        prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
      );
  };



  const GridActionsCellItem = ({ id }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.stopPropagation();  // Stop the event propagation
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => { setAnchorEl(null); setEditingTicketingAndRegistration(null); };
    const handleDeleteAction = () => { handleDeleteSingleItem(id); };
    const handleEditAction = () => { setEditingTicketingAndRegistration(ticketingAndRegistrations.find(ticketingAndRegistration => ticketingAndRegistration.id === id)); setShowModal(true); };
    const handleCloneAction = () => {
      const ticketingAndRegistrationToEdit = ticketingAndRegistrations.find(ticketingAndRegistration => ticketingAndRegistration.id === id);
      const clonedTicketingAndRegistration = { ...ticketingAndRegistrationToEdit, id: null, name: `${ticketingAndRegistrationToEdit.name} CLONED` };
      setEditingTicketingAndRegistration(clonedTicketingAndRegistration);
      setShowModal(true);
    };

    return (
      <>
        <IconButton aria-label="more" id="long-button" aria-controls={open ? 'long-menu' : undefined} aria-expanded={open ? 'true' : undefined} aria-haspopup="true" onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu id="long-menu" MenuListProps={{ 'aria-labelledby': 'long-button', sx: { backgroundColor: colors.greenAccent[700] , color: colors.grey[100] } }} anchorEl={anchorEl} open={open} onClose={handleClose}>
          <MenuItem onClick={handleCloneAction}><FileCopyIcon style={{ marginRight: 8 }} /> Clone Ticketing And Registration</MenuItem>
          <MenuItem onClick={handleDeleteAction}><DeleteIcon style={{ marginRight: 8 }} /> Delete Ticketing And Registration</MenuItem>
          <MenuItem onClick={handleEditAction}><EditIcon style={{ marginRight: 8 }} /> Edit Ticketing And Registration</MenuItem>
        </Menu>
      </>
    );
  };
  
  const handleEditAction = (id) => { setEditingTicketingAndRegistration(ticketingAndRegistrations.find(ticketingAndRegistration => ticketingAndRegistration.id === id)); setShowModal(true); };

  const handleOpenDrawer = (id) => {
  
    setEditingData(ticketingAndRegistrations.find(dataItem=> dataItem.id === id)); 
    setDrawerOpen(true);
    setShowModal(false);

  };

  return (
    <Card ref={ref} sx={{marginBottom: 2,backgroundColor: colors.dragAndDropDrop.tileBackgroundColor,marginLeft: '9px',marginRight: '9px',
      '&:hover': {
        backgroundColor: colors.dragAndDropDrop.tileBackgroundColorHover, 
      },
    }}
    >
      <CardContent>
  
      <Typography variant="h5" sx={{fontWeight:'800', cursor: 'pointer' }}  onClick={() => handleEditAction(ticketingAndRegistration.id)}>{ticketingAndRegistration.attendeeName}</Typography>
       

        <table style={{width:'100%'}}>
          <tr>
            <td> 
            <Typography variant="h7" sx={{fontWeight:'500', cursor: 'pointer', color:'#898580' }}  onClick={() => handleEditAction(ticketingAndRegistration.id)}>{ticketingAndRegistration.ticketingAndRegistrationNumber}</Typography>
            </td>
            <td>  
              <span style={{float:"right"}}>
              <IconButton onClick={() => handleOpenDrawer(ticketingAndRegistration.id)}>
                  <KeyboardDoubleArrowRightIcon/>
              </IconButton>
              </span>
            </td></tr></table>
          

        <Typography variant="body2" sx={{paddingTop:'5px',paddingBottom:'5px'}}>{ticketingAndRegistration.notes.length > 200 ? ticketingAndRegistration.notes.substring(0, 200) + '...' : ticketingAndRegistration.notes}</Typography>
        
        <table style={{width:'100%'}} cellSpacing={10}>
          <tr>
            <td style={{borderBottom: '1px solid #626262'}}>
              EVENT
            </td>
            <td style={{borderBottom: '1px solid #626262'}}>
              REGISTRATION STATUS
            </td>
          </tr>
          <tr>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box sx={{ backgroundColor: eventColorMap[ticketingAndRegistration.eventId], borderRadius: '13px', padding: '2px 8px',marginBottom: '4px',display: 'inline-block', color: theme.palette.mode === "dark" ? '#000000' : '#000000',fontWeight:'600'  }}>
                            {eventMap[ticketingAndRegistration.eventId]}
                        </Box>
                        </Typography>

            </td>
            <td>
               <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={ticketingAndRegistration.registrationStatus}
                                sx={{ 
                                    backgroundColor: registrationStatusColorMap[ticketingAndRegistration.registrationStatus], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { ticketingAndRegistration.registrationStatus }

                                </Box>
                    </Typography>

            </td>
          </tr>
        </table>

        <div style={{textAlign:'center'}}>
         <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={ticketingAndRegistration.registrationStatus}
                                sx={{ 
                                    backgroundColor: registrationStatusColorMap[ticketingAndRegistration.registrationStatus], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { ticketingAndRegistration.registrationStatus }

                                </Box>
                    </Typography>

        </div>

        <Box sx={{ padding: '0px', margin: '0px', height: '5px' }}>
              <div style={{ float: 'left' }}>

              <Checkbox 
              checked={deleteSelectionModel.includes(ticketingAndRegistration.id)}
              onChange={() => handleDeleteSelectionChange(ticketingAndRegistration.id)}
                                    
                                    sx={{
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        '&.Mui-checked': {
                                        color: theme.palette.mode === "dark" ? colors.greenAccent[600] : colors.greenAccent[400],
                                        },
                                    }}
                                    />

              </div>
        </Box>     
        <Box sx={{ padding: '0px', margin: '0px', height: '20px' }}>

              <div style={{ float: 'right' }}>
                <GridActionsCellItem {...ticketingAndRegistration} />
              </div>
        </Box>
      </CardContent>
    </Card>
  );
};


const TicketingAndRegistrations = ({ searchTerm }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [ticketingAndRegistrations, setTicketingAndRegistrations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingTicketingAndRegistration, setEditingTicketingAndRegistration] = useState(null);
  const [loading, setLoading] = useState(true);

  const [collectionModalOpen, setCollectionModalOpen] = useState(false);
  const [missingCollections, setMissingCollections] = useState([]);

  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [deleteSelectionModel, setDeleteSelectionModel] = useState([]);
  const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

  const [selectedIdsToDelete, setSelectedIdsToDelete] = useState([]);
  const [selectedIdsNotToDelete, setSelectedIdsNotToDelete] = useState([]);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode(); 

  const [standard, setStandard] = useState([]);
const [vIP, setVIP] = useState([]);
const [earlyBird, setEarlyBird] = useState([]);
const [student, setStudent] = useState([]);


  const [deleteId, setDeleteId] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [dependenciesAlertOpen, setDependenciesAlertOpen] = useState(false);

  const [deletionDependencies, setDeletionDependencies] = useState([]);

  const [processing, setProcessing] = useState(false);
  
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [selectedTicketingAndRegistration, setSelectedTicketingAndRegistration] = useState(null);

  const tilesDisplayCount = 6;

  const [visibleCount, setVisibleCount] = useState(tilesDisplayCount);

  const [showTestModeDialog, setShowTestModeDialog] = useState(false);

  const [suppressTestModeWarning, setSuppressTestModeWarning] = useState(
    localStorage.getItem('suppressTestModeSaveWarning') === 'true'
  );

  const [eventMap, setEventMap] = useState({});


  const [eventColorMap, setEventColorMap] = useState({});
const [registrationStatusColorMap, setRegistrationStatusColorMap] = useState({});


  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const eventSnapshot = await getDocs(query(collection(db, "events"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const eventData = eventSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const eventMap = eventData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.eventName }), {});
	setEventMap(eventMap);



            if (eventData.length === 0) {
	let missing = [];
	if (eventData.length === 0) missing.push("events");
	setMissingCollections(missing);
	setCollectionModalOpen(true);
}

        };
    
        fetchStaticData();
      }, [appUserAccountNumber, applicationMode]);
    
    

  const columns = [
	{ field: "eventId", headerName: "Event"},
	{ field: "ticketType", headerName: "Ticket Type"},
	{ field: "price", headerName: "Price"},
	{ field: "purchaseDate", headerName: "Purchase Date"},
	{ field: "registrationStatus", headerName: "Registration Status"},
	{ field: "attendeeName", headerName: "Attendee Name"},
	{ field: "attendeeEmail", headerName: "Attendee Email"},
	{ field: "attendeePhone", headerName: "Attendee Phone"},
	{ field: "paymentStatus", headerName: "Payment Status"},
	{ field: "checkIn", headerName: "Check-In"},
	{ field: "registrationFormCompleted", headerName: "Registration Form Completed"},
	{ field: "notes", headerName: "Notes"},
	{ field: "ticketingAndRegistrationNumber", headerName: "ticketingAndRegistrationNumber"},
	{ field: "id", headerName: "id"},
];



  useEffect(() => {

      if (!appUserAccountNumber) return; // Ensure appUserAccountNumber is available

      const ticketingAndRegistrationsRef = collection(db, "ticketingAndRegistrations");
      const ticketingAndRegistrationsQuery = query(ticketingAndRegistrationsRef, 
        where("appAccountNumber", "==", appUserAccountNumber),
        where("applicationMode", "==", applicationMode)
      );
    
      const unsubscribe = onSnapshot(ticketingAndRegistrationsQuery, (snapshot) => {
        const ticketingAndRegistrationsData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      setTicketingAndRegistrations(ticketingAndRegistrationsData);
    
      /*
      const filteredTicketingAndRegistrations = ticketingAndRegistrationsData.filter(ticketingAndRegistration =>
        columns.some(column => ticketingAndRegistration[column.field] && ticketingAndRegistration[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
      );
      */

      const filteredTicketingAndRegistrations = ticketingAndRegistrationsData.filter(ticketingAndRegistration =>
        columns.some(column => {
            let value = ticketingAndRegistration[column.field];
    
            let matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());

            if (matchFound == false)
            {
              if (column.field.endsWith('Id')) {
                  const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
    
                  try
                  {
                    value = eval(`${formatFunctionName}("${value}")`);
                    matchFound = value && value.toString().toLowerCase().trim().includes(searchTerm.toLowerCase().trim());
                  } catch(errr){}
              }
            }
    
            return matchFound;
    
        })
      );

      setStandard(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'Standard'));
setVIP(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'VIP'));
setEarlyBird(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'Early Bird'));
setStudent(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'Student'));


      setEventColorMap(generateEventColorMap(ticketingAndRegistrationsData, eventMap,theme));
setRegistrationStatusColorMap(generateRegistrationStatusColorMap(ticketingAndRegistrationsData,theme));


      setLoading(false);
    }, (error) => {
      setLoading(false);
      alert("Error fetching ticketingandregistrations: ", error);
    });

    return () => unsubscribe();
  }, [appUserAccountNumber,applicationMode]);

  useEffect(() => {
   
    /*
    const filteredTicketingAndRegistrations = ticketingAndRegistrations.filter(ticketingAndRegistration =>
      columns.some(column => ticketingAndRegistration[column.field] && ticketingAndRegistration[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
    );
    */

    const filteredTicketingAndRegistrations = ticketingAndRegistrations.filter(ticketingAndRegistration =>
      columns.some(column => {
          let value = ticketingAndRegistration[column.field];
  
          if (column.field.endsWith('Id')) {
              const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());
  
              try
              {
                value = eval(`${formatFunctionName}("${value}")`);
              } catch(errr){}
          }
  
          return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
      })
    );


    setStandard(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'Standard'));
setVIP(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'VIP'));
setEarlyBird(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'Early Bird'));
setStudent(filteredTicketingAndRegistrations.filter(cr => cr.ticketType === 'Student'));


}, [searchTerm]);


  //USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setEventColorMap(generateEventColorMap(ticketingAndRegistrations, eventMap,theme));
setRegistrationStatusColorMap(generateRegistrationStatusColorMap(ticketingAndRegistrations,theme));

}, [theme.palette.mode, ticketingAndRegistrations]);



  
 const formatEvent = value => {

    let formattedEvent = "";

    if (value != null && value !=="")
    {
    formattedEvent = eventMap[value];
    }
    
    return formattedEvent;
 };
    
                


   
  
  const moveCard = (item, toIndex, newTicketType) => {
    const fromList = getList(item.ticketType);
    const toList = getList(newTicketType);
    const [movedCard] = fromList.splice(item.index, 1);

    if (item.ticketType !== newTicketType) {
      movedCard.ticketType = newTicketType;
      toList.splice(toIndex, 0, movedCard);
    } else {
      fromList.splice(toIndex, 0, movedCard);
    }

    setList(item.ticketType, fromList);
    setList(newTicketType, toList);
    updateTicketType(movedCard, newTicketType);
  };

  const getList = (ticketType) => {
    switch (ticketType) {
      case 'Standard':
return standard;
case 'VIP':
return vIP;
case 'Early Bird':
return earlyBird;
case 'Student':
return student;

      default:
        return [];
    }
  };

  const setList = (ticketType, list) => {
    switch (ticketType) {
      case 'Standard':
setStandard(list);
case 'VIP':
setVIP(list);
case 'Early Bird':
setEarlyBird(list);
case 'Student':
setStudent(list);

        break;
      default:
        break;
    }
  };

  const updateTicketType = (ticketingAndRegistration, newTicketType) => {
    if (!ticketingAndRegistration || !ticketingAndRegistration.id) {
      console.error("Invalid change request: ", ticketingAndRegistration);
      return;
    }

    const ticketingAndRegistrationRef = doc(db, "ticketingAndRegistrations", ticketingAndRegistration.id);
    updateDoc(ticketingAndRegistrationRef, { ticketType: newTicketType })
      .then(() => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
  };


  const handleOpenModal = () => { setEditingTicketingAndRegistration(null); setShowModal(true); };
  
  const handleSaveTicketingAndRegistration = (ticketingAndRegistration) => {
    if (editingTicketingAndRegistration && editingTicketingAndRegistration.id) {
      setTicketingAndRegistrations(prevTicketingAndRegistrations => prevTicketingAndRegistrations.map(c => c.id === ticketingAndRegistration.id ? ticketingAndRegistration : c));
      saveTicketingAndRegistrationToDB(ticketingAndRegistration);
    } else {
      setTicketingAndRegistrations(prevTicketingAndRegistrations => [...prevTicketingAndRegistrations, { ...ticketingAndRegistration, id: prevTicketingAndRegistrations.length + 1 }]);
      addTicketingAndRegistrationToDB(ticketingAndRegistration);
    }
    setShowModal(false);
    setEditingTicketingAndRegistration(null);

    if (applicationMode === 'test' && !suppressTestModeWarning) {
      setShowTestModeDialog(true);
    }
  };

  const saveTicketingAndRegistrationToDB = async (ticketingAndRegistration) => {
    const ticketingAndRegistrationRef = doc(db, "ticketingAndRegistrations", ticketingAndRegistration.id);
    await updateDoc(ticketingAndRegistrationRef, ticketingAndRegistration);
  };

  const addTicketingAndRegistrationToDB = async (ticketingAndRegistration) => {
    
    const ticketingAndRegistrationNumber= await generateUniqueId("ticketingAndRegistrations",appUserAccountNumber);
    ticketingAndRegistration.ticketingAndRegistrationNumber = ticketingAndRegistrationNumber;

    ticketingAndRegistration.appAccountNumber = appUserAccountNumber;
    ticketingAndRegistration.applicationMode = applicationMode;

    const docRef = doc(db, 'ticketingAndRegistrations', ticketingAndRegistrationNumber);  
    await setDoc(docRef,ticketingAndRegistration);

  };

  

  const handleDeleteSelected = async () => {
    if (deleteSelectionModel.length === 0) {
      setDeleteAlertOpen(true);
      return;
    } else 
    {

      setProcessing(true);
      const idsToDelete = [];
      const idsNotToDelete = [];

      let allDeletionDependencies = [];

      //1. Identify Ids to Delete
      for (const id of deleteSelectionModel)
      {
        const dependencies = await hasDependencies(id);
    
        allDeletionDependencies = allDeletionDependencies.concat(dependencies); 

        setProcessing(false);
        
        if (dependencies.length === 0) {
          idsToDelete.push(id);
        } else 
        {
          idsNotToDelete.push(id);
        }
      }

      let uniqueDeletionDependencies = [...new Set(allDeletionDependencies)];

      setDeletionDependencies(uniqueDeletionDependencies);

      setSelectedIdsToDelete(idsToDelete);
      setSelectedIdsNotToDelete(idsNotToDelete);

      //2. Delete allowed ids

      setDeleteConfirmOpen(true);
      setProcessing(false);

    }

  };


  const handleAlertClose = () => {
    setDeleteAlertOpen(false);
  };

  
  const handleCancelDelete = () => {
      
    setDeleteConfirmOpen(false);
    setSelectedIdsToDelete([]);
    setSelectedIdsNotToDelete([]);
    setDeletionDependencies([]);
    
};


  const confirmDeleteSelected = async () => {
    try {
      const batch = writeBatch(db);
      selectedIdsToDelete.forEach(id => {
        const docRef = doc(db, "ticketingAndRegistrations", id);
        batch.delete(docRef);
      });

      await batch.commit();
      logToast("The records have been delete.");

      setDeleteSelectionModel([]);
      setDeleteConfirmOpen(false);
    } catch (error) {
      console.error("Error deleting documents: ", error);
    }
  };

  const openTicketingAndRegistrationDrawer = (id) => {

    const rowIndex = filteredTicketingAndRegistrations.findIndex(row => row.id === id);

    const ticketingAndRegistrationId = id;

    setSelectedRowIndex(rowIndex);

    const selectedTicketingAndRegistration = ticketingAndRegistrations.find(p => p.id === ticketingAndRegistrationId);
    if (selectedTicketingAndRegistration !== null && selectedTicketingAndRegistration != undefined)
    {  
      setSelectedTicketingAndRegistration(selectedTicketingAndRegistration);
      setDrawerOpen(true);
    }
  };

  const handleDrawerClose = () => {
      setDrawerOpen(false);
      setSelectedTicketingAndRegistration(null);
  };

  const hasDependencies = async (id) => {
    const dependencies = [];
  
    try {
      
      
  
    } catch (error) {
      console.error("Error checking dependencies:", error);
      return ["error"]; // Return an array with "error" to prevent deletion in case of an issue
    }
  
    return dependencies; // Return array of collection names with dependencies
  };
  
  const handleDeleteSingleItem = async (id) => {
  
    try
    {
      
      setProcessing(true);

      const dependencies = await hasDependencies(id);
    
      setProcessing(false);
      
      if (dependencies.length === 0) {
        setDeleteId(id);
        setConfirmOpen(true);
      } else {
        setDeleteId(id);
        setDeletionDependencies(dependencies);
        setDependenciesAlertOpen(true);
      }

    } catch(error)
    {
      setProcessing(false);
    }
  };

  const handleDependenciesAlertClose = async () => {
    
      setDependenciesAlertOpen(false);
      setDeletionDependencies([]);
    
  };


  const handleConfirmClose = async () => {
    try {
      if (deleteId) await deleteDoc(doc(db, "ticketingAndRegistrations", deleteId));
      setConfirmOpen(false);
      setDeleteId("");
      logToast("The record has been delete.");
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

  const handleCancelClose = () => {
    setConfirmOpen(false);
    setDeleteId("");
  };

  const handleOpenEdit = (id) => {

    setEditingTicketingAndRegistration(ticketingAndRegistrations.find(ticketingAndRegistration => ticketingAndRegistration.id === id));
    setDrawerOpen(false);
    setShowModal(true); 
  }

  /*
  const filteredTicketingAndRegistrations = ticketingAndRegistrations.filter(ticketingAndRegistration =>
    columns.some(column => ticketingAndRegistration[column.field] && ticketingAndRegistration[column.field].toString().toLowerCase().includes(searchTerm.toLowerCase()))
  );
  */
  
  const filteredTicketingAndRegistrations = ticketingAndRegistrations.filter(ticketingAndRegistration =>
    columns.some(column => {
        let value = ticketingAndRegistration[column.field];

        if (column.field.endsWith('Id')) {
            const formatFunctionName = 'format' + column.field.replace(/Id$/, '').replace(/^\w/, c => c.toUpperCase());

            try
            {
              value = eval(`${formatFunctionName}("${value}")`);
            } catch(errr){}
        }

        return value && value.toString().toLowerCase().includes(searchTerm.toLowerCase());
    })
  );



  const totalTicketingAndRegistrations = filteredTicketingAndRegistrations.length;


  return (
    <div>
      
        <Box m="20px">
          <Header title="Ticketing And Registrations By Ticket Type" subtitle="List of ticketing and registrations" />
          <Box m="0px 0 0px 0" pt="10px" display="flex" >
          
            <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleDeleteSelected} disabled={loading}>
                  <RemoveCircleOutlineIcon /> &nbsp; Delete Selected
                </Button>
              &nbsp;&nbsp;&nbsp;&nbsp;

                <Button variant="contained" color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={handleOpenModal} disabled={loading}>
                  <AddCircleOutlineIcon /> &nbsp; Add New
                </Button>
          </Box>
          {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                  <CircularProgress size={150} style={{ marginTop:'200px',color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }}  />
                </Box>
              ) : (
                <div>
                {ticketingAndRegistrations.length === 0 && (
                  
                  <Box display="flex" alignItems="center" justifyContent="center" height="100%" sx={{ flexDirection: 'column' }}>
                    <img src={noRecordImage} alt="No Data" style={{ width: 250, height: 250, opacity: 0.4 }} />
                    <Typography variant="h4" sx={{ color: colors.grey[300] }}>You don't have any ticketing and registrations yet</Typography>
                    <Typography variant="h5" sx={{ color: colors.grey[400], padding: '10px' }}>Click the <span style={{ color: '#dc0000', fontWeight: 'bold' }}>"ADD NEW"</span> button above</Typography>
                  </Box>
                
                )}

                {ticketingAndRegistrations.length > 0 && (
     
                <Box>
                {!isMobile ? (
     
                  <div>
                  
                  <div style={{ paddingTop:'7px',display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                   {/*   <div style={{ flex: '0 0 auto', textAlign: 'left', paddingLeft:'7px', fontSize:'11px' }}>
                          COLUMNS FILTERS
                      </div>
                    */}
                      <div style={{ margin: '0 auto', textAlign: 'center' }}>
                      You can drag and drop items from one column to the other
                      </div>
                  </div>
                  
                  <DndProvider backend={HTML5Backend}>
                    <Box display="flex" mt={1}>  {/* justifyContent="space-around" */}
                    
        <TicketTypeColumn
              title="Standard"
              ticketType="Standard"
              cards={standard}
              moveCard={moveCard} 
              setEditingTicketingAndRegistration={setEditingTicketingAndRegistration} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              ticketingAndRegistrations={ticketingAndRegistrations}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingTicketingAndRegistration} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              eventMap={eventMap}
formatEvent={formatEvent}
eventColorMap={eventColorMap}
registrationStatusColorMap={registrationStatusColorMap}
registrationStatusColorMap={registrationStatusColorMap}

            />
        

        <TicketTypeColumn
              title="VIP"
              ticketType="VIP"
              cards={vIP}
              moveCard={moveCard} 
              setEditingTicketingAndRegistration={setEditingTicketingAndRegistration} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              ticketingAndRegistrations={ticketingAndRegistrations}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingTicketingAndRegistration} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              eventMap={eventMap}
formatEvent={formatEvent}
eventColorMap={eventColorMap}
registrationStatusColorMap={registrationStatusColorMap}
registrationStatusColorMap={registrationStatusColorMap}

            />
        

        <TicketTypeColumn
              title="Early Bird"
              ticketType="Early Bird"
              cards={earlyBird}
              moveCard={moveCard} 
              setEditingTicketingAndRegistration={setEditingTicketingAndRegistration} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              ticketingAndRegistrations={ticketingAndRegistrations}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingTicketingAndRegistration} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              eventMap={eventMap}
formatEvent={formatEvent}
eventColorMap={eventColorMap}
registrationStatusColorMap={registrationStatusColorMap}
registrationStatusColorMap={registrationStatusColorMap}

            />
        

        <TicketTypeColumn
              title="Student"
              ticketType="Student"
              cards={student}
              moveCard={moveCard} 
              setEditingTicketingAndRegistration={setEditingTicketingAndRegistration} 
              setDeleteId={setDeleteId} 
              setConfirmOpen={setConfirmOpen} 
              ticketingAndRegistrations={ticketingAndRegistrations}
              setShowModal={setShowModal} 
              colors={colors} 
              theme={theme} 
              deleteSelectionModel={deleteSelectionModel} 
              setDeleteSelectionModel={setDeleteSelectionModel} 
              titleColor="#000000" 
              setEditingData={setEditingTicketingAndRegistration} 
              handleDeleteSingleItem={handleDeleteSingleItem}
              setDrawerOpen={setDrawerOpen}
              eventMap={eventMap}
formatEvent={formatEvent}
eventColorMap={eventColorMap}
registrationStatusColorMap={registrationStatusColorMap}
registrationStatusColorMap={registrationStatusColorMap}

            />
        


                    </Box>
                  </DndProvider>
                  </div>

                ) : (    

                  <div className="tile-wrapper">

                  {filteredTicketingAndRegistrations.slice(0, visibleCount).map((item, index) => ( 
                        <Tile key={index} data={item} ticketingAndRegistrations={ticketingAndRegistrations} setShowModal={setShowModal} setEditingData={setEditingTicketingAndRegistration} handleDeleteSingleItem={handleDeleteSingleItem} setCollectionModalOpen={setCollectionModalOpen} setMissingCollections={setMissingCollections} deleteSelectionModel={deleteSelectionModel} setDeleteSelectionModel={setDeleteSelectionModel} />
                       ))}
              
              
                  </div>

                )}
                </Box>

                )}
                

                </div>
            )}
        </Box>


        <TicketingAndRegistrationDrawerModal
              drawerOpen={drawerOpen}
              handleDrawerClose={handleDrawerClose} 
              handleArrowUpClick="" 
              handleArrowDownClick=""
              selectedTicketingAndRegistration={editingTicketingAndRegistration}
              ticketingAndRegistrations={ticketingAndRegistrations} 
              handleOpenEdit={handleOpenEdit}
          />

      <TicketingAndRegistrationInputModal isOpen={showModal} onClose={() => setShowModal(false)} onSave={handleSaveTicketingAndRegistration} ticketingAndRegistration={editingTicketingAndRegistration} />

      <Dialog open={confirmOpen} onClose={handleCancelClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this ticketing and registration?
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
            No
          </Button>
          <Button onClick={handleConfirmClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteConfirmOpen} onClose={handleCancelDelete} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Confirm Delete"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            
          
            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length == 0) && 
              <div>Are you sure you want to delete the selected ticketing and registrations? </div>
            }

            {(selectedIdsToDelete.length > 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected ticketing and registrations with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>

                However, the remaining ticketing and registrations with ids: &nbsp;
                <b>{selectedIdsToDelete.join(", ")}</b><br></br> 
                will be deleted If you select <b>YES</b>. <br></br><br></br>

                Do you want to proceed deleting <b>{selectedIdsToDelete.join(", ")}</b>? 
              </div>
            }

            {(selectedIdsToDelete.length == 0 && selectedIdsNotToDelete.length > 0) && 
              <div>
                The selected ticketing and registrations with ids: &nbsp;
                <b>{selectedIdsNotToDelete.join(", ")}</b><br></br> 
                cannot be deleted because they are linked to other dependent records in the following components:<br></br> <br></br>
                <b>{deletionDependencies.join(", ")}</b>. 
                <br></br><br></br>
                Please remove these dependencies before proceeding with the deletion.
                <br></br><br></br>

                <b><u>TIP</u>:</b> You can go to each of the components listed above and type each of the ids listed one by one in the search box to find the dependent records.
              </div>
            }

          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleCancelDelete} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }}>
          {selectedIdsToDelete.length > 0 ? 'No' : 'OK'}
          </Button>
          {selectedIdsToDelete.length > 0 &&
          <Button onClick={confirmDeleteSelected} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            Yes
          </Button>
          }
        </DialogActions>
      </Dialog>
      
      <Dialog open={collectionModalOpen} aria-labelledby="collection-modal-title" aria-describedby="collection-modal-description">
        <DialogTitle id="collection-modal-title">{"Missing Records"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="collection-modal-description">
            {missingCollections.includes("events") && <span>Please add at least one <b>event</b> before managing ticketing and registrations. <br></br></span>}

          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" sx={{ backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }}  onClick={() => window.location.href = `/${missingCollections[0]}`} color="primary">
            Go to {missingCollections[0]}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteAlertOpen} onClose={handleAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
            No ticketing and registrations selected for deletion.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={dependenciesAlertOpen} onClose={handleDependenciesAlertClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" sx={{ backgroundColor: colors.greenAccent[700] }}>{"Delete Alert"}</DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText id="alert-dialog-description">
          This ticketing and registration cannot be deleted because it is linked <br></br> 
          to other dependent records in the following components:<br></br> <br></br>
          <b>{deletionDependencies.join(", ")}</b>. 
          <br></br><br></br>
          Please remove these dependencies before proceeding with the deletion.
          <br></br><br></br>

          <b><u>TIP</u>:</b> You can go to each of the components listed above and type <b>{deleteId}</b> in the search box to find the dependent records.
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button onClick={handleDependenciesAlertClose} sx={{ backgroundColor: colors.greenAccent[600], color: colors.primary[100],'&:hover': { backgroundColor: colors.greenAccent[800] } }} autoFocus>
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showTestModeDialog} onClose={() => setShowTestModeDialog(false)}>
        <DialogTitle sx={{ backgroundColor: colors.greenAccent[700] }}>
          {"Test Mode Notice"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: colors.greenAccent[700] }}>
          <DialogContentText>
            You are currently in <strong>Test Mode</strong>. This mode is intended for training and testing purposes only.
            <br /><br />
            If your intention is to add a live project record, please turn off test mode before proceeding.
          </DialogContentText>
          <Box mt={2}>
            <label>
              <input
                type="checkbox"
                checked={suppressTestModeWarning}
                onChange={(e) => {
                  const checked = e.target.checked;
                  setSuppressTestModeWarning(checked);
                  localStorage.setItem('suppressTestModeSaveWarning', checked);
                }}
              />{" "}
              Don't show this message again when saving in test mode
            </label>
          </Box>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: colors.greenAccent[700] }}>
          <Button
            onClick={() => setShowTestModeDialog(false)}
            sx={{
              backgroundColor: colors.greenAccent[600],
              color: colors.primary[100],
              '&:hover': { backgroundColor: colors.greenAccent[800] }
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>


    {processing && (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      zIndex={2000}
      pointerEvents="none"
    >
      <CircularProgress size={120} style={{ color: theme.palette.mode === "dark" ? 'white' : 'darkGray' }} />
    </Box>
  )}

    </div>

  );
};

const TicketTypeColumn = ({ title, ticketType, cards, moveCard, setEditingTicketingAndRegistration, setDeleteId, setConfirmOpen, ticketingAndRegistrations, setShowModal, colors, theme,deleteSelectionModel,setDeleteSelectionModel,titleColor,setEditingData,handleDeleteSingleItem,setDrawerOpen ,eventMap, formatEvent,eventColorMap,registrationStatusColorMap}) => {
  const [, drop] = useDrop({
    accept: ItemType.CARD,
    drop: (item) => {
      moveCard(item, cards.length, ticketType);
    },
  });

  return (
    <Box
    ref={drop}
    sx={{ width: '30%', minHeight: '400px', backgroundColor: colors.dragAndDropDrop.droppableAreaBackgroundColor, padding: 0, marginBottom: 5, borderTopLeftRadius: '10px', borderTopRightRadius: '10px', borderBottomLeftRadius: '4px', borderBottomRightRadius: '4px', marginRight:2 }}
  >
    <Box 
      sx={{
        backgroundColor: titleColor === '#000000' ?  stringToColorLight(title) : titleColor,
        color: titleColor === '#000000' ? '#000000' : '#FFFFFF',
        padding: '0px',
        borderTopLeftRadius: '10px',
        borderTopRightRadius: '10px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        marginBottom: '10px',
        marginTop: '0px',
        marginLeft: '0px',
        marginRight: '0px',
        textAlign: 'center',
        minHeight:'45px',
        paddingTop:'10px'
      }}
    >
      <Typography variant="h5" style={{fontWeight:'600',fontSize:'17px'}}>{title} ({cards.length})</Typography>
    </Box>
      {cards.map((card, index) => (
        <DraggableCard
          key={card.id}
          ticketingAndRegistration={card}
          index={index}
          moveCard={(from, to) => moveCard(from, to, ticketType)}
          ticketType={ticketType} 
          setEditingTicketingAndRegistration={setEditingTicketingAndRegistration} 
          setDeleteId={setDeleteId} 
          setConfirmOpen={setConfirmOpen} 
          ticketingAndRegistrations={ticketingAndRegistrations} 
          setShowModal={setShowModal} 
          colors={colors} 
          theme={theme} 
          deleteSelectionModel={deleteSelectionModel} 
          setDeleteSelectionModel={setDeleteSelectionModel} 
          setEditingData={setEditingData} 
          handleDeleteSingleItem={handleDeleteSingleItem}
          setDrawerOpen={setDrawerOpen}
          eventMap={eventMap}
formatEvent={formatEvent}
eventColorMap={eventColorMap}
registrationStatusColorMap={registrationStatusColorMap}

        />
      ))}
    </Box>
  );
};


export default TicketingAndRegistrations;
